import script from "./Powder.vue?vue&type=script&setup=true&lang=js"
export * from "./Powder.vue?vue&type=script&setup=true&lang=js"

import "./Powder.vue?vue&type=style&index=0&id=7f1694ab&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7f1694ab"]])

export default __exports__